import PaymentSettings from '@/admin/pages/settings/payment-settings';
import { settingsQuery } from '@/admin/queries/settings';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/payment')({
	loader: ({ context }) => context.queryClient.ensureQueryData(settingsQuery()),
	component: PaymentSettings,
});
